document.addEventListener('DOMContentLoaded', () => {

  // Build modals for each link inside .customizer-step-header__message
  document.querySelectorAll('.customizer-step-header__message').forEach((messageEl) => {
    const messageId = messageEl.getAttribute('data-message-id');

    messageEl.querySelectorAll('a').forEach((link, linkIndex) => {
      const linkId = linkIndex + 1;
      const modalId = `modal-${messageId}-${linkId}`;

      link.classList.add('modal-trigger');
      link.setAttribute('data-modal-ref', modalId);

      const modalOverlay = document.createElement('div');
      modalOverlay.className = 'helper-modal modal-overlay';
      modalOverlay.setAttribute('data-modal', modalId);
      modalOverlay.innerHTML =
        `<div class="modal-content" id="modalContent-${messageId}-${linkId}">
          <div class="modal-content__header">
            <button type="button" class="button grey modal-close-btn"><span>&times;</span></button>
          </div>
          <div class="modal-content__body"></div>
        </div>`;

      messageEl.insertAdjacentElement('afterend', modalOverlay);
    });
  });

  // Handle modal trigger clicks
  const modalTriggers = document.querySelectorAll('.modal-trigger');

  modalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const modalRef = trigger.getAttribute('data-modal-ref');
      if (!modalRef) return;

      // Find the matching modal overlay
      const modalOverlay = document.querySelector(`.modal-overlay[data-modal="${modalRef}"]`);
      if (!modalOverlay) return;

      modalOverlay.classList.add('active');

      const helpUrl = trigger.href;
      const modalContent = modalOverlay.querySelector('.modal-content__body');

      fetch(helpUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const mainContent = doc.getElementById('main-content');
          if (mainContent && modalContent) {
            modalContent.innerHTML = mainContent.innerHTML;
            if (typeof SlideShow !== 'undefined') {
              new SlideShow();
              requestAnimationFrame(() => {
                modalContent.querySelectorAll('.carousel').forEach((carousel) => {
                  const flkty = Flickity.data(carousel);
                  if (flkty) flkty.resize();
                });
              });
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching help content:', error);
        });
    });
  });

  // Handle modal overlay clicks (close on backdrop click)
  const modalOverlays = document.querySelectorAll('.helper-modal.modal-overlay');

  modalOverlays.forEach((overlay) => {
    overlay.addEventListener('click', (e) => {
      // Only remove active class if clicking directly on the overlay (not on modal-content)
      if (e.target === overlay) {
        overlay.classList.remove('active');
      }
    });
  });

  // Prevent modal-content clicks from closing the modal
  const modalContents = document.querySelectorAll('.helper-modal .modal-content');

  modalContents.forEach((content) => {
    content.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  // Handle modal close button clicks
  const modalCloseBtns = document.querySelectorAll('.helper-modal .modal-close-btn');

  modalCloseBtns.forEach((closeBtn) => {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Find the closest parent modal-overlay
      const modalOverlay = closeBtn.closest('.helper-modal.modal-overlay');
      if (modalOverlay) {
        modalOverlay.classList.remove('active');
      }
    });
  });
});
